import { Link, useLocation } from 'react-router-dom';

// Utility for Admin Sidebar to avoid using window.location.href directly
export function AdminSidebar() {
    const location = useLocation();

    return (
        <aside className="w-64 min-h-[calc(100vh-4rem)] bg-white border-r border-slate-200">
            <nav className="p-4 space-y-2">
                <Link 
                    to="/adminpanel/dashboard"
                    className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                        location.pathname === '/adminpanel/dashboard' 
                        ? 'bg-[#0A192F] text-white' 
                        : 'text-slate-600 hover:bg-slate-50'
                    }`}
                >
                    Client Tenants
                </Link>
                <Link 
                    to="/adminpanel/master-view"
                    className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                        location.pathname === '/adminpanel/master-view' 
                        ? 'bg-[#0A192F] text-white' 
                        : 'text-slate-600 hover:bg-slate-50'
                    }`}
                >
                    Master Ledger View
                </Link>
            </nav>
        </aside>
    );
}